var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoPositivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.2 26.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #277105;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,10.1c0,.9.6,1.7,1.3,1.7s1.3-.8,1.3-1.7-.6-1.7-1.3-1.7-1.3.8-1.3,1.7ZM18.2,10.1c0,.9-.6,1.7-1.3,1.7s-1.3-.8-1.3-1.7.6-1.7,1.3-1.7,1.3.8,1.3,1.7ZM7.4,16c.2.3,2.2,2.7,5.5,2.8,3.5,0,5.6-2.5,5.8-2.8M25.3,13.1c0,6.8-5.5,12.2-12.2,12.2S.8,19.9.8,13.1,6.3.8,13.1.8s12.2,5.5,12.2,12.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoPositivo);
export default __webpack_public_path__ + "static/media/emo-positivo.503b926747b7868a9d9d1ae8547be5c2.svg";
export { ForwardRef as ReactComponent };